export default __webpack_public_path__ + "static/media/29t.5925a45d.jpg";